import React, { useEffect,useState  } from "react";
import "@styles/components/ui/FloatingBtn.scss";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { gaEvent } from "@utils/gaEvent";
import { useNavigate } from "react-router-dom";



const FloatingBtn = ({}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isChinese = i18n.language === "hk";
    const navigate = useNavigate();

  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );

//  useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         // 當 HomeKv 可見比例 < 0.5 就顯示
//         setShowFixed(entry.intersectionRatio < 0.01);
//       },
//       {
//         root: null,
//         threshold: 0.5, // 元素剩返 50% 可見時觸發
//       }
//     );

//     if (kvRef.current) {
//       observer.observe(kvRef.current);
//     }

//     return () => {
//       if (kvRef.current) {
//         observer.unobserve(kvRef.current);
//       }
//     };
//   }, []);

  return (
          <Box className="fixed-container">
            {!memberInfoData && (
              <img
                onClick={() => {
                  gaEvent("clubs_homepage", "join_clubs", "join_clubs_button_3");
                  navigate("/login");
                }}
                className="join-now-button"
                src={
                  isChinese
                    ? `${process.env.PUBLIC_URL}/assets/images/home/join_now_button_hk.gif`
                    : `${process.env.PUBLIC_URL}/assets/images/home/join_now_button_hk_en.gif`
                }
              />
            )}
          </Box>
  );
};




export default FloatingBtn;
